import { ff } from '../../theme';

/** Wallet tokens, mapped onto the creator revamp `ff` palette (flat ink hero, lime fills, no green). */
export const walletColors = {
  pageBg: 'white',
  textPrimary: ff.ink,
  textSecondary: ff.text2,
  textMuted: ff.muted,
  cardBorder: ff.line,
  /** Former green accent; now ink text (lime is a fill only). */
  accentGreen: ff.ink,
  /** Former green tint; now the lime surface fill. */
  accentGreenSoft: ff.limeSurface,
  /** Flat ink hero card. */
  heroGradient: ff.ink,
  heroDropShadow: 'none',
  heroInsetShadow: 'none',
  /** Withdraw / set-up button fill on the ink hero. */
  withdrawButtonGradient: ff.lime,
  withdrawButtonShadow: 'none',
  withdrawButtonInsetShadow: 'none',
  lastPayoutText: 'rgba(255,255,255,0.6)',
} as const;

/** Full-page shell — white, like the other revamped creator pages. */
export const walletPageShellSx = {
  bg: walletColors.pageBg,
  minH: '100svh',
  w: '100%',
} as const;
